export enum PermissionEnum {
  ADMIN_ACCESS = "admin_access",
  DEPARTMENT_MANAGEMENT_ACCESS = "department_management_access",
  DOCUMENT_REVIEW_ACCESS = "document_review_access",
  DOCUMENT_MANAGEMENT_ACCESS = "document_management_access",
  ENROLLMENT_MANAGEMENT_ACCESS = "enrollment_management_access",
  INVESTIGATE_APPLICATIONS_ACCESS = "investigate_applications_access",
  LICENSE_MANAGEMENT_ACCESS = "license_management_access",
  ORGANIZATION_MANAGEMENT_ACCESS = "organization_management_access",
  QUEUE_MANAGEMENT_ACCESS = "queue_management_access",
  REVIEW_APPLICATIONS_ACCESS = "review_applications_access",
  ROLE_MANAGEMENT_ACCESS = "role_management_access",
  USER_MANAGEMENT_ACCESS = "user_management_access",
  WORKFORCE_MANAGEMENT_ACCESS = "workforce_management_access",
  APPROVER_ACCESS = "approver_access",
}
